exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".latest-infor {\n  width: 260px;\n  height: auto;\n  margin-top: -4px; }\n  .latest-infor .latest-body ul {\n    margin: 0;\n    padding: 0;\n    list-style: none; }\n    .latest-infor .latest-body ul li {\n      margin: 5px 0;\n      color: #41474c;\n      letter-spacing: 1px;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      cursor: pointer;\n      transition: all .3s linear; }\n      .latest-infor .latest-body ul li:hover span {\n        color: #14cc9e; }\n      .latest-infor .latest-body ul li label {\n        font-weight: normal;\n        margin-right: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/job/latest-information/latest-information.component.scss
// module id = ../../../../../src/app/job/latest-information/latest-information.component.scss
// module chunks = job.module